/** localStorage key + helpers for preferred UI locale (en | es). */

export type AppLocale = 'en' | 'es'

export const LOCALE_STORAGE_KEY = 'rbcfs.preferred_locale'

export function isAppLocale(value: unknown): value is AppLocale {
  return value === 'en' || value === 'es'
}

export function readStoredLocale(): AppLocale | null {
  try {
    const raw = localStorage.getItem(LOCALE_STORAGE_KEY)
    return isAppLocale(raw) ? raw : null
  } catch {
    return null
  }
}

export function writeStoredLocale(locale: AppLocale): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch {
    // ignore quota / private mode
  }
}

/** Profile preference wins when present; otherwise device cache; default en. */
export function resolvePreferredLocale(
  profileLocale: string | null | undefined,
  storedLocale: AppLocale | null = readStoredLocale()
): AppLocale {
  if (isAppLocale(profileLocale)) return profileLocale
  if (storedLocale) return storedLocale
  return 'en'
}
